import React from "react"

class EmailMessageDataType extends React.Component{

  render() {
  	if (this.props.row && this.props.row.show_email_body_templated_path) {
	    return (
	    	<div>
	    		<a href={this.props.row.show_email_body_templated_path} className="modal-iframe" data-fullscreen="true">{I18n.t('view_message')}</a>
	    	</div>
	    );
  	} else {
	    return (
	    	<div>
	    		<a href={this.props.row.show_sent_email_body_path} className="modal-iframe" data-fullscreen="true">{I18n.t('view_message')}</a> &nbsp;
	    		<a href={this.props.row.resend_path} className="modal-iframe" data-fullscreen="true">{I18n.t('resend_email')}</a>
	    	</div>
	    );
  	}
  }

};

export default EmailMessageDataType